import axios from 'axios'
import {  Loading } from 'element-ui'
import config from '@/conf/config'
import { getHeader } from './header'

// 创建loading实例
let loadingInstance = null

// 创建axios实例
const service = axios.create({
  baseURL: '/', // 基础URL
  timeout: config.apiTimeout // 请求超时时间
})

// 显示加载动画
const showLoading = () => {
  loadingInstance = Loading.service({
    lock: true,
    text: '加载中...',
    spinner: 'el-icon-loading',
    background: 'rgba(0, 0, 0, 0.7)'
  })
}

// 隐藏加载动画
const hideLoading = () => {
  if (loadingInstance) {
    loadingInstance.close()
    loadingInstance = null
  }
}

// 请求拦截器
service.interceptors.request.use(
  config => {
    console.log('request拦截器 - 开始处理请求')
    console.log('request拦截器 - 原始config:', config)
    
    let _header = getHeader();
    console.log('request拦截器 - getHeader返回值:', _header)
    
    // 在发送请求之前做些什么
    config.headers['Content-Type'] = 'application/json'
    config.headers['Accept'] = 'application/json'
    config.headers['app-id'] = _header['app-id']
    config.headers['TRANSACTION-ID'] = _header['TRANSACTION-ID']
    config.headers['REQ-TIME'] = _header['REQ-TIME']
    config.headers['SIGN'] = _header['SIGN']
    config.headers['user-id'] = _header['user-id']
    config.headers['X-Requested-With'] = 'XMLHttpRequest'
    // 这里可以添加token等认证信息
    config.headers['Authorization'] = _header['Authorization']
    
    console.log('request拦截器 - 设置baseURL前的url:', config.url)
    if (config.url.indexOf('/app/') == -1 && config.url.indexOf('/callComponent/') == -1) {
      config.baseURL = "/app"
      console.log('request拦截器 - 设置baseURL为:', "/app")
    }
    
    console.log('request拦截器 - 最终请求URL:', config.baseURL + config.url)
    console.log('request拦截器 - 请求方法:', config.method)
    console.log('request拦截器 - 请求数据:', config.data)
    console.log('request拦截器 - 请求头:', config.headers)
    
    // GET请求不显示加载动画，其他请求显示
    if (config.method !== 'get' && config.showLoading !== false) {
      showLoading()
      console.log('request拦截器 - 显示加载动画')
    }

    console.log('request拦截器 - 请求处理完成，返回config')
    return config
  },
  error => {
    console.error('request拦截器 - 请求错误:', error)
    // 请求错误时也要隐藏加载动画
    hideLoading()
    return Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  response => {
    console.log('response拦截器 - 收到响应')
    console.log('response拦截器 - 响应状态:', response.status)
    console.log('response拦截器 - 响应数据:', response.data)
    console.log('response拦截器 - 响应配置:', response.config)
    
    // 隐藏加载动画
    hideLoading()
    console.log('response拦截器 - 隐藏加载动画')
    
    return response
  },
  error => {
    console.error('response拦截器 - 响应错误:', error)
    console.error('response拦截器 - 错误信息:', error.message)
    console.error('response拦截器 - 错误堆栈:', error.stack)
    console.error('response拦截器 - 错误响应:', error.response)

    // 隐藏加载动画
    hideLoading()
    console.log('response拦截器 - 隐藏加载动画')

    // 判断是否为401未授权错误
    if (error.response && error.response.status === 401) {
      console.error('response拦截器 - 401未授权错误')
      // 清除本地存储的token
      localStorage.removeItem('token')
      console.log('response拦截器 - 清除本地存储的token')
      // 跳转到登录页面
      window.location.href = '/#/views/user/login'
      console.log('response拦截器 - 跳转到登录页面')

      // Message({
      //   message: '登录已过期，请重新登录',
      //   type: 'error',
      //   duration: 5 * 1000
      // })
    }

    return Promise.reject(error)
  }
)

export default service 